import React from 'react';
import { Flex, Text } from '@pega/cosmos-react-core';
import styled, { css } from 'styled-components';
import useLocalTranslation from '../../../../../hooks/useLocalTranslation';

const StyledFlex = styled.div(
  ({ theme }) =>
    css`
      background-color: ${theme.base.colors.gray.light};
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    `,
);
const pegaLogoStyle = {
  display: 'flex',
};

const Footer: React.FC = () => {
  const translate = useLocalTranslation();

  return (
    <Flex as={StyledFlex} container={{ alignItems: 'center', justify: 'center' }}>
      <Text variant="secondary">{translate('powered_by')}</Text>
      &nbsp;&nbsp;
      <a href="https://www.pega.com" target="blank" rel="noopener">
        <img
          src="https://cdn.artemis.pega.digital/pega.ico"
          height={30}
          alt={translate('powered_by_pega')}
          style={pegaLogoStyle}
        />
      </a>
    </Flex>
  );
};

export default Footer;
